import { render, staticRenderFns } from "./UpcomingSortition.vue?vue&type=template&id=5b1804de&scoped=true&"
import script from "./UpcomingSortition.vue?vue&type=script&lang=js&"
export * from "./UpcomingSortition.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingSortition.vue?vue&type=style&index=0&id=5b1804de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1804de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
